module.exports = __webpack_public_path__ + "img/banner1.0ebc7eb7.png";